import React, { useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { REACH_POST_LINK, type ReachPost } from './reach';
import { WritePost } from './WritePost';

/**
 * "Write a fresh post" for a missed post that's old news (Prototype v16, UX
 * review round 9): the composer on that post's channel, with the site's page
 * filled in — the post's own link when it's on the site, else the same
 * article's address on the site (reachPostLink.ownUrl), else nothing. The old
 * post stays where it was, for Skip.
 */
export function useFreshPost(onPosted?: () => void) {
  const apollo = useApolloClient();
  const [fresh, setFresh] = useState<{ channelIds: string[]; link: string } | null>(null);

  const open = async (post: ReachPost) => {
    let link = '';
    const url = post.postUrl?.trim() || '';
    if (url && !post.offSiteDomain) link = url;
    else if (url) {
      try {
        const { data } = await apollo.query<{ reachPostLink: { ownUrl?: string | null } | null }>({
          query: REACH_POST_LINK,
          variables: { postId: post.id },
          fetchPolicy: 'network-only',
        });
        link = data?.reachPostLink?.ownUrl || '';
      } catch {
        /* no link filled in; the person can add one */
      }
    }
    setFresh({ channelIds: [post.socialProfileId], link });
  };

  const node = fresh ? (
    <WritePost
      channelIds={fresh.channelIds}
      link={fresh.link}
      onClose={() => setFresh(null)}
      onPosted={() => {
        setFresh(null);
        onPosted?.();
      }}
    />
  ) : null;

  return { open, node };
}
